if (document.getElementById('page-leave')) {
  pageLeave()
}
function pageLeave() {
  window.addEventListener('keydown', function (e) {
    // 退会理由が書かれたら対応する退会理由のチェックも入れる
    if (!e.target.classList.contains('js-leaveText')) {
      return
    }
    document.getElementById(e.target.dataset.leaveCheck).checked = true
  })
}
